import { OPEN_NETWORK_ERROR_MODAL, CLOSE_NETWORK_ERROR_MODAL } from "./actionTypes";

function openNetworkErrorModal() {
  return {
    type: OPEN_NETWORK_ERROR_MODAL
  };
}

function closeNetworkErrorModal() {
  return {
    type: CLOSE_NETWORK_ERROR_MODAL
  };
}

export {
  openNetworkErrorModal,
  closeNetworkErrorModal
};